import * as React from 'react'
import { Navigate } from 'react-router-dom'

import { RequestTypeDetailDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const PurchaseRequestsSettingsPage = React.lazy(
  () => import('modules/procurement/pages/SettingsPage')
)

const RequestTypeDetailPage = React.lazy(
  () => import('modules/procurement/pages/RequestTypeDetailPage')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.procurement.path,
      handle: {
        meta: () => ({
          title: i18n.t('company_settings.finance.procurement.title'),
          illustration: 'receipt',
        }),
      },
      children: [
        {
          index: true,
          element: <Navigate to={navigation.settings.procurement.requests.path} replace />,
        },
        {
          path: navigation.settings.procurement.requests.path,
          element: <PurchaseRequestsSettingsPage />,
          handle: {
            meta: () => ({
              title: i18n.t('procurement.purchase_requests.settings.sidebar.requests'),
            }),
          },
        },
        {
          path: navigation.settings.procurement.taskForms.path,
          element: <PurchaseRequestsSettingsPage />,
          handle: {
            meta: () => ({
              title: i18n.t('procurement.purchase_requests.settings.sidebar.forms'),
            }),
          },
        },
        {
          path: navigation.settings.procurement.requestType.path,
          handle: {
            meta: () => ({
              title: i18n.t('procurement.purchase_requests.settings.sidebar.requests'),
              backLink: { href: navigation.settings.procurement.requests.fullPath() },
            }),
          },
          children: [
            {
              index: true,
              element: (
                <Navigate to={navigation.settings.procurement.requests.fullPath()} replace />
              ),
            },
            {
              path: navigation.settings.procurement.requestType.id.path,
              element: <RequestTypeDetailPage />,
              handle: {
                resource: true,
                meta: ({ watchQuery, params, session }) => {
                  return watchQuery({
                    query: RequestTypeDetailDocument,
                    variables: {
                      requestTypeId: String(params.id),
                      companyId: session.company.id,
                    },
                  }).map(({ data }) => {
                    const requestType = data?.procurement?.typesConnection?.nodes?.[0]

                    return {
                      title:
                        requestType?.name ||
                        i18n.t('procurement.purchase_requests.settings.types.detail.breadcrumb'),
                      illustration: 'receipt',
                    }
                  })
                },
              },
            },
          ],
        },
      ],
    },
  ]
}

export default settingsRoutes
